<template>
  <div class="workspace__container__view container-scroll" style="padding-bottom: 60px;">
    <div class="workspace__container__view__header column box-style">
      <div class="workspace__container__view__header__filter">
        <div class="container__inputs">
          <div class="settings-input">
            <label>{{ $t("workspace.spot_detail.station") }}
              <small v-if="(submitted || openModalSchedule) && v$.modelSpot.stationId.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
              <small v-else>*</small>
            </label>
            <Multiselect
              v-model="modelSpot.stationId"
              :placeholder="$t('workspace.spot_detail.select') + $t('workspace.spot_detail.station')"
              :searchable="false"
              :canDeselect="false"
              :canClear="false"
              track-by="name"
              valueProp="id"
              label="name"
              :options="listStations"
              :class="{'invalid': submitted && v$.modelSpot.stationId.$invalid}"
              :style="{'color': !modelSpot.stationId ? '#757575' : '#ffffffde'}"
              @select="changeInput" />

            <!-- <select name="station" id="station" v-model="modelSpot.stationId" :class="{'invalid': submitted && v$.modelSpot.stationId.$invalid}" @change="changeInput" :style="{'color': !modelSpot.stationId ? '#757575' : '#ffffffde'}">
              <option :value="null" selected>{{ $t("workspace.spot_detail.select") }} {{ $t("workspace.spot_detail.station") }}</option>
              <option v-for="station in listStations" :value="station.id" :key="station.id">{{ station.name }}</option>
            </select> -->
          </div>
          <div class="settings-input">
            <label id="num_int">{{ $t("workspace.spot_detail.num_int") }}</label>
            <input type="text" name="num_int" :value="`${modelSpot.internalOrderNumber}/${modelSpot.internalOrderNumberRevision}`" readonly disabled>
          </div>
          <div class="settings-input">
            <label id="num_ord">{{ $t("workspace.spot_detail.num_ord") }}</label>
            <input type="text" name="num_ord" v-model="modelSpot.agencyOrderNumber" autocomplete="off" :placeholder="`${$t('workspace.spot_detail.enter')} ${$t('workspace.spot_detail.num_ord')}`" @change="changeInput">
          </div>
          <div class="settings-input">
            <label for="discount">{{ $t("workspace.spot_detail.discount") }} (%)</label>
            <input type="text" autocomplete="off" id="discount" v-model="modelSpot.discount" @change="changeInput"> 
          </div>
          <div class="settings-input">
            <label>{{ $t("workspace.spot_detail.raw") }}</label>
            <input type="text" autocomplete="off" id="name" v-model="modelSpot.monthlyFee" @change="changeInput">
          </div>
        </div>
      </div>
      <div class="workspace__container__view__header__filter">
        <div class="container__inputs">
          <div class="settings-input">
            <label for="agency">{{ $t("workspace.spot_detail.agency") }}</label>
            <Multiselect
              v-model="modelSpot.adAgencyId"
              :placeholder="$t('workspace.spot_detail.select') + $t('workspace.spot_detail.agency')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="true"
              :options="listAgencies" 
              @select="changeInput" />


            <!-- <select id="agency" v-model="modelSpot.adAgencyId" @change="changeInput">
              <option :value="null" selected>{{ $t("workspace.spot_detail.select") }} {{ $t("workspace.spot_detail.agency") }}</option>  
              <option v-for="agency in listAgencies" :value="agency.id" :key="agency.id">{{ agency.code }} - {{ agency.name }}</option>  
            </select>  -->
          </div>
          <div class="settings-input">
            <label for="origin">{{ $t("workspace.spot_detail.origin") }}</label>
            <Multiselect
              v-model="modelSpot.originId"
              :placeholder="$t('workspace.spot_detail.select') + $t('workspace.spot_detail.origin')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="true"
              :options="listOrigin" 
              @select="changeInput" />

            <!-- <select id="origin" v-model="modelSpot.originId" @change="changeInput">
              <option :value="null" selected>{{ $t("workspace.spot_detail.select") }} {{ $t("workspace.spot_detail.origin") }}</option>  
              <option v-for="origin in listOrigin" :value="origin.id" :key="origin.id">{{ origin.code }} - {{ origin.description }}</option>  
            </select>  -->
          </div>
          <div class="settings-input">
            <label for="pay_method">{{ $t("workspace.spot_detail.pay_method") }}</label>
            <Multiselect
              v-model="modelSpot.payMethodId"
              :placeholder="$t('workspace.spot_detail.select') + $t('workspace.spot_detail.pay_method')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="false"
              :options="listMethod" 
              @select="changeInput" />
            <!-- <select id="pay_method" v-model="modelSpot.payMethodId" @change="changeInput">
              <option :value="null" selected>{{ $t("workspace.spot_detail.select") }} {{ $t("workspace.spot_detail.pay_method") }}</option>  
              <option v-for="method in listMethod" :key="method.id" :value="method.id">{{method.code}} - {{method.description}}</option>  
            </select>  -->
          </div>
          <div class="settings-input">
            <label for="discount2">{{ $t("workspace.spot_detail.discount") }} 2 (%)</label>
            <input type="text" autocomplete="off" id="discount2" v-model="modelSpot.discount2" @change="changeInput"> 
          </div>
          <div class="settings-input">
            <label for="procentage">{{ $t("workspace.spot_detail.porcentage") }} (%)</label>
            <input type="text" autocomplete="off" id="porcentage" v-model="modelSpot.adAgencyPercentage" @change="changeInput"> 
          </div>
        </div>
      </div>
      <div class="workspace__container__view__header__filter">
        <div class="container__inputs">
          <div class="settings-input">
            <label for="customer">{{ $t("workspace.spot_detail.customer") }}
              <small v-if="submitted && v$.modelSpot.clientId.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
              <small v-else>*</small>
            </label>
            <Multiselect
              v-model="modelSpot.clientId"
              :placeholder="$t('workspace.spot_detail.select') + $t('workspace.spot_detail.customer')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="true"
              :canDeselect="false"
              :canClear="false"
              :options="listClients" 
              @select="changeInput"
              :class="{'invalid': submitted && v$.modelSpot.clientId.$invalid}" />

            <!-- <select id="customer" v-model="modelSpot.clientId" :class="{'invalid': submitted && v$.modelSpot.clientId.$invalid}" @change="changeInput">
              <option :value="null" selected>{{ $t("workspace.spot_detail.select") }} {{ $t("workspace.spot_detail.customer") }}</option>  
              <option v-for="client in listClients" :value="client.id" :key="client.id">{{client.code}} - {{ client.name }}</option>  
            </select>  -->
          </div>
        </div>
        <div class="container__inputs">
          <div class="settings-input">
            <label for="line">{{ $t("workspace.spot_detail.line_of_business") }}
              <small v-if="submitted && v$.modelSpot.spotCategoryId.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
              <small v-else>*</small>
            </label>
            <Multiselect
              v-model="modelSpot.spotCategoryId"
              :placeholder="$t('workspace.spot_detail.select') + $t('workspace.spot_detail.line_of_business')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="true"
              :canDeselect="false"
              :canClear="false"
              :options="listSpots" 
              @select="changeInput"
              :class="{'invalid': submitted && v$.modelSpot.spotCategoryId.$invalid}" />

            <!-- <select id="line" v-model="modelSpot.spotCategoryId" :class="{'invalid': submitted && v$.modelSpot.spotCategoryId.$invalid}" @change="changeInput">
              <option :value="null" selected>{{ $t("workspace.spot_detail.select") }} {{ $t("workspace.spot_detail.line_of_business") }}</option>  
              <option v-for="spots in listSpots" :value="spots.id" :key="spots.id">{{spots.code}} - {{ spots.name }}</option>  
            </select>  -->
          </div>
          <div class="settings-input">
            <label for="executive">{{ $t("workspace.spot_detail.executive") }}</label>
            <Multiselect
              v-model="modelSpot.accountExecutiveId"
              :placeholder="$t('workspace.spot_detail.select') + $t('workspace.spot_detail.executive')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="true"
              :options="listAccountExecutive" 
              @select="changeInput" />
            <!-- <select id="executive"  v-model="modelSpot.accountExecutiveId" @change="changeInput">
              <option :value="null" selected>{{ $t("workspace.spot_detail.select") }} {{ $t("workspace.spot_detail.executive") }}</option>  
              <option v-for="executive in listAccountExecutive" :value="executive.id" :key="executive.id">{{executive.code}} - {{ executive.name }}</option>  
            </select>  -->
          </div>
          <div class="settings-input">
            <label for="discount3">{{ $t("workspace.spot_detail.discount") }} 3 (%)</label>
            <input type="text" autocomplete="off" id="discount3" v-model="modelSpot.discount3" @change="changeInput"> 
          </div>
        </div>
      </div>
      <div class="workspace__container__view__header__filter">
        <div class="container__inputs">
          <div class="settings-input">
            <label for="name">{{ $t("workspace.spot_detail.name") }}
              <small v-if="submitted && v$.modelSpot.name.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
              <small v-else>*</small></label>
            <input type="text" id="name" v-model="modelSpot.name" autocomplete="off" :placeholder="`${$t('modal.placeholder_insert')} ${$t('workspace.spot_detail.name')}`" :class="{'invalid': submitted && v$.modelSpot.name.$invalid}" @change="changeInput">
          </div>
          <div class="settings-input double-column">
            <label for="comments">{{ $t("workspace.spot_detail.comments") }}</label>
            <textarea v-model="modelSpot.comment" name="comments" id="comments" cols="30" rows="10" :placeholder="`${$t('modal.placeholder_insert')} ${$t('workspace.spot_detail.comments')}`" @change="changeInput"></textarea>
          </div>
          <div class="settings-input">
            <label for="discount4">{{ $t("workspace.spot_detail.discount") }} 4 (%)</label>
            <input type="text" autocomplete="off" id="discount4" v-model="modelSpot.discount4" @change="changeInput"> 
          </div>
        </div>
      </div>
      <div class="component-modal__row" v-if="submitted && v$.modelSpot.$invalid">
        <div class="modal__form-error">
          <i class="material-icons">info_outline</i>
          <span v-html="$t('modal.common.required_message', {inputs : v$.modelSpot.$silentErrors.map(error => $t(`workspace.spot_detail.${error.$property == 'clientId' ? 'client' : error.$property == 'spotCategoryId' ? 'line_of_business' : error.$property == 'stationId' ? 'station' : error.$property}`)).join(', ') })"></span>
        </div>
      </div>      
    </div>

    <div style="margin-bottom: 12px;">
      <div class="workspace__container__view__table__header">
        <h3>{{ $t("workspace.spot_detail.detail_programming") }}</h3>
        <div class="settings-input" style="width: fit-content">
          <input type="month" v-model="detailProgrammingMonthSelect" @change="filterAdvancedSchedules" :disabled="spotAdvancedSchedulesFiltered.length > 0">
        </div>
        <button class="outline small" v-if="detailProgrammingMonthSelect != ''" @click="createOrEdit('SPOT-PROGRAMMING_SPOT_DETAILED-SHEDULE_CREATE-EDIT', {monthSelect: detailProgrammingMonthSelect})">{{$t("workspace.schedules.add")}}</button>
      </div>
      <table class="workspace__container__view__table">
        <thead>
          <tr>
            <th class="column-time">
              <div class="column-filtered" @click="(sortAdvanced.filter == 'startTime' ? sortAdvanced.desc = !sortAdvanced.desc : sortAdvanced.filter = 'startTime'); orderAdvancedSchedules()">
                <span>{{ $t("workspace.spot_detail.time_init") }}</span> 
                <i class="material-icons" :class="{'active': sortAdvanced.filter == 'startTime'}">{{sortAdvanced.filter == 'startTime' ? (sortAdvanced.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th class="column-time">
              <div class="column-filtered" @click="(sortAdvanced.filter == 'endTime' ? sortAdvanced.desc = !sortAdvanced.desc : sortAdvanced.filter = 'endTime'); orderAdvancedSchedules()">
                <span>{{ $t("workspace.spot_detail.time_end") }}</span> 
                <i class="material-icons" :class="{'active': sortAdvanced.filter == 'endTime'}">{{sortAdvanced.filter == 'endTime' ? (sortAdvanced.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th>
              <div class="column-filtered" @click="(sortAdvanced.filter == 'fileName' ? sortAdvanced.desc = !sortAdvanced.desc : sortAdvanced.filter = 'fileName'); orderAdvancedSchedules()">
                <span>{{ $t("workspace.spot_detail.file") }}</span>
                <i class="material-icons" :class="{'active': sortAdvanced.filter == 'fileName'}">{{sortAdvanced.filter == 'fileName' ? (sortAdvanced.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th class="column-s">{{ $t("workspace.spot_detail.fee") }}</th>
            <template v-for="i in [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]">
              <th v-if="getDateInMonth(i) != ''" :key="i" class="center column-xs" 
                :class="{'hover': positionHover.x >= 0 && positionHover.x == i - 1}">
                  <small style="font-weight: normal; opacity: .7; font-size: 10px">{{getDateInMonth(i)}}</small><br>
                  {{i}}
              </th>
            </template>
            <th class="center">{{ $t("workspace.spot_detail.actions") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(spot, idxSpot) in spotAdvancedSchedulesFiltered" :key="spot.id">
            <td class="column-time">{{spot.startTime}}</td>
            <td class="column-time">{{spot.endTime}} </td>
            <td class="td-filename" :title="spot.fileName">{{spot.fileName}} </td>
            <td class="column-s">{{spot.timeFee}}</td>
            <template v-for="i in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]">
              <td 
                v-if="getDateInMonth(i + 1) != ''"
                :key="i" class="center column-xs" 
                :class="{
                  'with-value': spot.occurrences[i] > 0,
                  'hover': (positionHover.x >= i && positionHover.y == idxSpot) || (positionHover.x == i && positionHover.y >= idxSpot)
                }"
                @mouseover="setPositionHover(i, idxSpot)"
                @mouseleave="setPositionHover(-1, -1)">
                <input 
                  type="number" 
                  class="input__occurrences"
                  v-model="spot.occurrences[i]"
                  @focus="$event.target.select()"
                  @focusout="spot.occurrences[i] == '' ? spot.occurrences[i] = 0 : null"
                  @keyup.enter="$event.target.parentElement.nextElementSibling.childNodes[0].focus()"
                  @change="changeInput">
              </td>
            </template>
            <td class="actions">
              <i class="material-icons" @click="createOrEdit('SPOT-PROGRAMMING_SPOT_DETAILED-SHEDULE_CREATE-EDIT', {...spot, edit: true})">edit</i>
              <i class="material-icons" @click="deleteItem(spot, 'EMIT_removeAdvancedSchedule')">delete</i>
            </td>
          </tr>
          <tr v-if="spotAdvancedSchedulesFiltered.length == 0">
            <td colspan="36">{{$t('workspace.not_have_loaded')}} <strong>{{ $t("workspace.spot_detail.detail_programming") }}</strong>. {{$t('workspace.please')}} <strong style="text-decoration: underline; cursor: pointer" @click="createOrEdit('SPOT-PROGRAMMING_SPOT_DETAILED-SHEDULE_CREATE-EDIT', {monthSelect: detailProgrammingMonthSelect})">{{ $t("workspace.schedules.add") }}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="border-top: 1px solid #ffffff52; padding-top: 12px;">
      <div class="workspace__container__view__table__header">
        <h3>{{ $t("workspace.spot_detail.simple_programming") }}</h3>
        <button class="outline small" @click="createOrEdit('SPOT-PROGRAMMING_SPOT_SIMPLE-SCHEDULE_CREATE-EDIT')">{{$t("workspace.schedules.add")}}</button>
      </div>
      <table class="workspace__container__view__table">
        <thead>
          <tr>
            <th class="column-time">
              <div class="column-filtered" @click="(sortSimple.filter == 'startDate' ? sortSimple.desc = !sortSimple.desc : sortSimple.filter = 'startDate'); orderSimpleSchedules()">
                <span>{{ $t("workspace.spot_detail.date_init") }}</span> 
                <i class="material-icons" :class="{'active': sortSimple.filter == 'startDate'}">{{sortSimple.filter == 'startDate' ? (sortSimple.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th class="column-time">
              <div class="column-filtered" @click="(sortSimple.filter == 'endDate' ? sortSimple.desc = !sortSimple.desc : sortSimple.filter = 'endDate'); orderSimpleSchedules()">
                <span>{{ $t("workspace.spot_detail.date_end") }}</span> 
                <i class="material-icons" :class="{'active': sortSimple.filter == 'endDate'}">{{sortSimple.filter == 'endDate' ? (sortSimple.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th class="td-filename">
              <div class="column-filtered" @click="(sortSimple.filter == 'fileName' ? sortSimple.desc = !sortSimple.desc : sortSimple.filter = 'fileName'); orderSimpleSchedules()">
                <span>{{ $t("workspace.spot_detail.file") }}</span>
                <i class="material-icons" :class="{'active': sortSimple.filter == 'fileName'}">{{sortSimple.filter == 'fileName' ? (sortSimple.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th class="center column-s">{{ $t("days_of_week.monday").substring(0,3) }}.</th>
            <th class="center column-s">{{ $t("days_of_week.tuesday").substring(0,3) }}.</th>
            <th class="center column-s">{{ $t("days_of_week.wednesday").substring(0,3) }}.</th>
            <th class="center column-s">{{ $t("days_of_week.thursday").substring(0,3) }}.</th>
            <th class="center column-s">{{ $t("days_of_week.friday").substring(0,3) }}.</th>
            <th class="center column-s">{{ $t("days_of_week.saturday").substring(0,3) }}.</th>
            <th class="center column-s">{{ $t("days_of_week.sunday").substring(0,3) }}.</th>
            <th class="center" style="width: 60px">
              <div class="column-filtered" @click="(sortSimple.filter == 'commercialBreakSpotPosition' ? sortSimple.desc = !sortSimple.desc : sortSimple.filter = 'commercialBreakSpotPosition'); orderSimpleSchedules()">
                <span>Pos.</span>
                <i class="material-icons" :class="{'active': sortSimple.filter == 'commercialBreakSpotPosition'}">{{sortSimple.filter == 'commercialBreakSpotPosition' ? (sortSimple.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th class="column-detail">{{ $t("workspace.spot_detail.detail") }}</th>
            <th class="center">{{ $t("workspace.spot_detail.actions") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="spot in modelSpot.spotSimpleSchedules" :key="spot.id"> 
            <td class="column-time">{{formatDate(spot.startDate)}}</td>
            <td class="column-time">{{formatDate(spot.endDate)}}</td>
            <td class="td-filename" :title="spot.filename">{{spot.filename}}</td>
            <td class="center column-s"><i class="material-icons">{{spot.monday == 1 ? 'done': 'close'}}</i></td>
            <td class="center column-s"><i class="material-icons">{{spot.tuesday == 1 ? 'done': 'close'}}</i></td>
            <td class="center column-s"><i class="material-icons">{{spot.wednesday == 1 ? 'done': 'close'}}</i></td>
            <td class="center column-s"><i class="material-icons">{{spot.thursday == 1 ? 'done': 'close'}}</i></td>
            <td class="center column-s"><i class="material-icons">{{spot.friday == 1 ? 'done': 'close'}}</i></td>
            <td class="center column-s"><i class="material-icons">{{spot.saturday == 1 ? 'done': 'close'}}</i></td>
            <td class="center column-s"><i class="material-icons">{{spot.sunday == 1 ? 'done': 'close'}}</i></td>
            <td class="center" style="width: 60px" :title="spot.spotType == 2 ? spot.commercialBreakSpotPosition : getTranslatePosition(spot.commercialBreakSpotPosition)">
              <template v-if="spot.spotType == 2">{{spot.commercialBreakSpotPosition}}</template>
              <template v-else>{{`${getTranslatePosition(spot.commercialBreakSpotPosition)}`.substring(0,3)}}.</template>
            </td>
            <td class="column-detail">
              <template v-if="spot.timeMode == 0">{{spot.startTime}} - {{spot.endTime}} ({{spot.occurrences}})</template>
              <template v-if="spot.timeMode == 1">{{getShowById(spot.showId)}} ({{spot.occurrences}})</template>
              <template v-if="spot.timeMode == 2">{{spot.exactTimes.replaceAll(',', ', ')}}</template>
            </td>
            <td class="actions">
              <i class="material-icons" @click="createOrEdit('SPOT-PROGRAMMING_SPOT_SIMPLE-SCHEDULE_CREATE-EDIT', {...spot, edit: true})">edit</i>
              <i class="material-icons" @click="deleteItem(spot, 'EMIT_removeSimpleSchedule')">delete</i>
            </td>
          </tr>
          <tr v-if="modelSpot.spotSimpleSchedules.length == 0">
            <td colspan="13">{{$t('workspace.not_have_loaded')}} <strong>{{ $t("workspace.spot_detail.simple_programming") }}</strong>. {{$t('workspace.please')}} <strong style="text-decoration: underline; cursor: pointer" @click="createOrEdit('SPOT-PROGRAMMING_SPOT_SIMPLE-SCHEDULE_CREATE-EDIT')">{{ $t("workspace.schedules.add") }}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="workspace__container__view__actions bg-black">
      <div>
        <button v-if="listStations.length > 1" :class="{'disabled': !(!tabChanges && modelSpot.id) || !modelSpot.id}" :disabled="!(!tabChanges && modelSpot.id) || !modelSpot.id" @click="createOrEdit('SPOT-PROGRAMMING_SPOT_SPOT-COPY', modelSpot)">{{ $t("workspace.spot_detail.copy_commercial") }}</button>
        <button :class="{'disabled': !(!tabChanges && modelSpot.id) || !modelSpot.id}" :disabled="!(!tabChanges && modelSpot.id) || !modelSpot.id" @click="cancelAndReplace()">{{ $t("workspace.spot_detail.cancel_replace") }}</button>
      </div>
      <button :disabled="!tabChanges" :class="{'disabled': !tabChanges}" @click="modelSpot.id ? update() : save()">{{ $t("workspace.spot_detail.save") }}</button>
      <button :disabled="!tabChanges" :class="{'disabled': !tabChanges}" @click="saveAndTest()">{{ $t("workspace.spot_detail.save_test") }}</button>
    </div>
  </div>
</template>
<script>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { required } from '@vuelidate/validators';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import persistentData from '@/plugins/persistentData';
import useVuelidate from '@vuelidate/core';
import eventBus from '@/plugins/eventBus';
import moment from 'moment';
import Multiselect from '@vueform/multiselect';

export default {
  components: {
    Multiselect
  },
  setup() {
		const v$ = useVuelidate();
    const { t } = useI18n();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const listStations = computed(() => store.getters.station_stations({name: ''}));
    const listAgencies = computed(() => store.getters.adAgency_agenciesList);
    const listOrigin = computed(() => store.getters.origin_originList);
    const listClients = computed(() => store.getters.client_clientsList);
    const listMethod = computed(() => store.getters.payMethod_methodList);
    const listSpots = computed(() => store.getters.spotsCategory_spotsList);
    const listAccountExecutive = computed(() => store.getters.accountExecutive_accountExecutiveList);
    const getShowById = computed(() => showId => store.getters.show_programById(showId));
    const detailProgrammingMonthSelect = ref(moment().format('YYYY-MM'));
    const modelSpot = ref({
      spotCategoryId: null,
      comment: "",
      clientId: null,
      adAgencyId: null,
      monthlyFee: 0,
      discount: 0,
      adAgencyPercentage: 0,
      dueDate: null,
      internalOrderNumber: 0,
      internalOrderNumberRevision: 0,
      agencyOrderNumber: "",
      accountExecutiveId: null,
      discount2: 0,
      name: "",
      initDate: null,
      month: null,
      originId: null,
      payMethodId: null,
      discount3: 0,
      discount4: 0,
      stationId: null,
      spotAdvancedSchedules: [],
      spotSimpleSchedules: []
    });
    const internalReferenceSpot = new Date().getUTCMilliseconds();
    const spotAdvancedSchedulesFiltered = ref([]);
    const submitted = ref(false);
    const tabChanges = ref(false);
    const openModalSchedule = ref(false);
    const positionHover = ref({
      x: -1,
      y: -1
    })
    const sortAdvanced = ref({
      filter: '',
      desc: true
    })
    const sortSimple = ref({
      filter: '',
      desc: true
    })
  
    onMounted(async () => {
      store.dispatch('loading_setActive', true);
      
      // Get values from localStorage
      if (localStorage.getItem('spot_advanced_sort')) {
        sortAdvanced.value = JSON.parse(localStorage.getItem('spot_advanced_sort'));
      } else {
        sortAdvanced.value = {
          filter: 'startTime',
          desc: true
        }
      }
      if (localStorage.getItem('spot_simple_sort')) {
        sortSimple.value = JSON.parse(localStorage.getItem('spot_simple_sort'));
      } else {
        sortSimple.value = {
          filter: 'startDate',
          desc: true
        }
      }
      
      await store.dispatch('station_getAll');
      await store.dispatch('adAgency_getAll');
      await store.dispatch('origin_getAll');
      await store.dispatch('client_getAll');
      await store.dispatch('payMethod_getAll');
      await store.dispatch('spotsCategory_getAll');
      await store.dispatch('accountExecutive_getAll');
      await store.dispatch('show_getAll');

      const tab = store.getters.tabs_getActive;
      tabChanges.value = tab.extendedData.changes;
      if (tab.extendedData.changes) {
        modelSpot.value = {...tab.extendedData};
        filterAdvancedSchedules();
        
        store.dispatch('tabs_updateTab', {
          id: route.params.id,
          extendedData: tab.extendedData
        });
      } else {
        if (listStations.value.length == 1) modelSpot.value.stationId = listStations.value[0].id;

        if (!route.params.id.includes('create')) {
          const response = await store.dispatch('spots_getById', {id: route.params.id})
          modelSpot.value = {...response};
          filterAdvancedSchedules();
        }

        store.dispatch('tabs_updateTab', {
          id: route.params.id,
          extendedData: modelSpot.value
        });
      }

      // Setear valor en el input de mes
      if (modelSpot.value.spotAdvancedSchedules.length > 0) {
        detailProgrammingMonthSelect.value = moment(modelSpot.value.spotAdvancedSchedules[0].date).format('YYYY-MM');
        filterAdvancedSchedules();
      }

      orderSimpleSchedules();

      eventBus.$on('addSimpleSchedule', (model) => {
        // Validación por si esta editando/creando en varias pestañas
        if (model.internalReferenceSpot != internalReferenceSpot) return;
        delete model['internalReferenceSpot'];
        model.idAux = new Date().getUTCMilliseconds()
        modelSpot.value.spotSimpleSchedules.push(model);
        orderSimpleSchedules();
        changeInput();
      });
      eventBus.$on('editSimpleSchedule', (model) => {
        if (model.internalReferenceSpot != internalReferenceSpot) return;
        delete model['internalReferenceSpot'];
        const positionIndex = modelSpot.value.spotSimpleSchedules.findIndex(schedule => (schedule.id == 0 ? schedule.idAux : schedule.id) == (model.id == 0 ? model.idAux : model.id));
        modelSpot.value.spotSimpleSchedules[positionIndex] = model;
        orderSimpleSchedules();
        changeInput();
      });
      eventBus.$on('removeSimpleSchedule', (model) => {
        if (model.internalReferenceSpot != internalReferenceSpot) return;
        delete model['internalReferenceSpot'];
        console.log(modelSpot.value.spotSimpleSchedules);
        modelSpot.value.spotSimpleSchedules = modelSpot.value.spotSimpleSchedules.filter(schedule => (schedule.id == 0 ? schedule.idAux : schedule.id) != (model.id == 0 ? model.idAux : model.id));
        orderSimpleSchedules();
        changeInput();
      });
      eventBus.$on('addAdvancedSchedule', (model) => {
        if (model.internalReferenceSpot != internalReferenceSpot) return;
        delete model['internalReferenceSpot'];
        model.idAux = new Date().getUTCMilliseconds()
        modelSpot.value.spotAdvancedSchedules.push(model);
        filterAdvancedSchedules();
        changeInput();
      });
      eventBus.$on('editAdvancedSchedule', (model) => {
        if (model.internalReferenceSpot != internalReferenceSpot) return;
        delete model['internalReferenceSpot'];
        const positionIndex = modelSpot.value.spotAdvancedSchedules.findIndex(schedule => (schedule.id == 0 ? schedule.idAux : schedule.id) == (model.id == 0 ? model.idAux : model.id));
        modelSpot.value.spotAdvancedSchedules[positionIndex] = model;
        filterAdvancedSchedules();
        changeInput();
      });
      eventBus.$on('removeAdvancedSchedule', (model) => {
        if (model.internalReferenceSpot != internalReferenceSpot) return;
        delete model['internalReferenceSpot'];
        console.log(modelSpot.value.spotAdvancedSchedules)
        console.log(model)
        modelSpot.value.spotAdvancedSchedules = modelSpot.value.spotAdvancedSchedules.filter(schedule => (schedule.id == 0 ? schedule.idAux : schedule.id) != (model.id == 0 ? model.idAux : model.id));
        filterAdvancedSchedules();
        changeInput();
      });
      store.dispatch('loading_setActive', false);
    });

    onUnmounted(() => {
      eventBus.$off('addSimpleSchedule');
      eventBus.$off('editSimpleSchedule');
      eventBus.$off('removeSimpleSchedule');
      eventBus.$off('addAdvancedSchedule');
      eventBus.$off('editAdvancedSchedule');
      eventBus.$off('removeAdvancedSchedule');
    });

    async function createOrEdit(active, item) {
      if (!modelSpot.value.stationId) {
        openModalSchedule.value = true;
      } else {
        openModalSchedule.value = false;
        await store.dispatch('modal_setActive', {active: active, props: {internalReferenceSpot, ...item, stationId: modelSpot.value.stationId}});
      }
    }

    async function deleteItem(item, actionDelete) {
      const modelDelete = {};
      switch (actionDelete) {
        case 'EMIT_removeSimpleSchedule':
          modelDelete.id = item.id;
          modelDelete.idAux = item.idAux;
          modelDelete.startDate = formatDate(item.startDate);
          modelDelete.endDate = formatDate(item.endDate);
          modelDelete.fileName = item.filename;
          modelDelete.monday = item.monday == 1 ? t("workspace.schedules.active"): t("workspace.schedules.disabled");
          modelDelete.tuesday = item.tuesday == 1 ? t("workspace.schedules.active"): t("workspace.schedules.disabled");
          modelDelete.wednesday = item.wednesday == 1 ? t("workspace.schedules.active"): t("workspace.schedules.disabled");
          modelDelete.thursday = item.thursday == 1 ? t("workspace.schedules.active"): t("workspace.schedules.disabled");
          modelDelete.friday = item.friday == 1 ? t("workspace.schedules.active"): t("workspace.schedules.disabled");
          modelDelete.saturday = item.saturday == 1 ? t("workspace.schedules.active"): t("workspace.schedules.disabled");
          modelDelete.sunday = item.sunday == 1 ? t("workspace.schedules.active"): t("workspace.schedules.disabled");
          if (item.timeMode == 0) modelDelete.detail = `${item.startTime} - ${item.endTime} (${item.occurrences})`;
          if (item.timeMode == 1) modelDelete.detail = `${this.getShowById(item.showId)} (${item.occurrences})`;
          if (item.timeMode == 2) modelDelete.detail = `${item.exactTimes}`;
          break;
        case 'EMIT_removeAdvancedSchedule':
          modelDelete.id = item.id;
          modelDelete.idAux = item.idAux;
          modelDelete.startTime = item.startTime;
          modelDelete.endTime = item.endTime;
          modelDelete.fileName = item.fileName;
          modelDelete.timeFee = item.timeFee;
          break;
      }
      await store.dispatch('modal_setActive', {active: 'COMMON_DELETE', props: {internalReferenceSpot, ...modelDelete}, actionDelete});
    }

    function formatDate(date) {
      if (!date) return '-';
      return moment(date).format(moment().locale(persistentData.get('lang'))._locale._longDateFormat.L);
    }

    function getDateInMonth(date) {
      const month = Number(detailProgrammingMonthSelect.value.split('-')[1]);
      const year = Number(detailProgrammingMonthSelect.value.split('-')[0]);
      const dateInMonth = moment().locale(persistentData.get('lang')).set({'year': year, 'month': (month - 1), date});
      
      if (moment(dateInMonth).month() == (month - 1)) {
        return dateInMonth.format('ddd')
      }
      return ''
    }

    async function save() {
      submitted.value = true;
      if (!v$.value.modelSpot.$invalid) {
        try {
          const modelResponse = await store.dispatch('spots_create', modelSpot.value)
          modelSpot.value = modelResponse;
          const tab = store.getters.tabs_getActive;
          tabChanges.value = false;
          tab.id = modelSpot.value.id;
          await store.dispatch('tabs_updateTab', {
            ...tab,
            extendedData: modelSpot.value
          })
          router.push(`/${tab.module}/${tab.name}/${tab.id}`);
          submitted.value = false;
        } catch (error) {
          console.error(error);
        }
      }
    }

    async function update() {
      submitted.value = true;
      if (!v$.value.modelSpot.$invalid) {
        store.dispatch('spots_update', modelSpot.value);
        const tab = store.getters.tabs_getActive;
        tabChanges.value = false;
        await store.dispatch('tabs_updateTab', {
          ...tab,
          extendedData: modelSpot.value
        })
        submitted.value = false;
      }
    }

    async function saveAndTest() {
      submitted.value = true;
      if (!v$.value.modelSpot.$invalid) {
        const actionDispatch = modelSpot.value.id ? 'spots_saveAndTest' : 'spots_createAndTest';
        const response = await store.dispatch(actionDispatch, modelSpot.value);
        const tab = store.getters.tabs_getActive;
        tabChanges.value = false;
        await store.dispatch('tabs_updateTab', {
          ...tab,
          extendedData: modelSpot.value
        })
        
        submitted.value = false;

        if (response != 'SAVED_OK_BUT_NO_SCHEDULES') {
          // Abrir la tab
          const tabResult = {
            id: response.requestId,
            module: tab.module,
            name: 'spot_test',
            extendedData: {
              stationName: response.stationName,
              tabActive: tab,
              urlTab: route.path
            }
          }
          await store.dispatch('tabs_addTab', tabResult);
          await store.dispatch('tabs_setActive', tabResult);
          router.push(`/spot_programming/spot_test/${response.requestId}`);
        }
      }
    }

    function setPositionHover(x, y) {
      positionHover.value.x = x;
      positionHover.value.y = y;
    }

    const orderBy = function (list, property, order) {
      return list.sort((a, b) => {
        if (property == 'commercialBreakSpotPosition') {
          return order ? a[property] - b[property] : b[property] - a[property];
        } else if (property == 'fileName') {
          return order ? (a[property] ?? '').localeCompare(b[property] ?? '') : (b[property] ?? '').localeCompare(a[property] ?? '');
        } else {
          if (order) {
            return moment(a[property], 'hh:mm').isBefore(moment(b[property], 'hh:mm')) ? -1 : 1;
          } else {
            return moment(a[property], 'hh:mm').isBefore(moment(b[property], 'hh:mm')) ? 1 : -1;
          }
        }
      });
    }

    function filterAdvancedSchedules() {
      const month = Number(detailProgrammingMonthSelect.value.split('-')[1]);
      spotAdvancedSchedulesFiltered.value = modelSpot.value.spotAdvancedSchedules.filter(spot => moment(spot.date, 'YYYY-MM-DD').month() == (month - 1));
      orderAdvancedSchedules();
    }

    function orderAdvancedSchedules() {
      spotAdvancedSchedulesFiltered.value = orderBy(modelSpot.value.spotAdvancedSchedules, sortAdvanced.value.filter, sortAdvanced.value.desc);
      localStorage.setItem('spot_advanced_sort', JSON.stringify({
        filter: sortAdvanced.value.filter,
        desc: sortAdvanced.value.desc
      }));
    }

    function orderSimpleSchedules() {
      modelSpot.value.spotSimpleSchedules = orderBy(modelSpot.value.spotSimpleSchedules, sortSimple.value.filter, sortSimple.value.desc);
      localStorage.setItem('spot_simple_sort', JSON.stringify({
        filter: sortSimple.value.filter,
        desc: sortSimple.value.desc
      }));
    }

    async function changeInput() {
      const tab = store.getters.tabs_getActive;
      tabChanges.value = true;
      await store.dispatch('tabs_updateTab', {
        ...tab,
        extendedData: modelSpot.value
      })
      await store.dispatch('tabs_setPropChanges', {id: route.params.id, changes: true});
    }

    function getTranslatePosition(position) {
      let translate = '-';
      switch(position) {
        case 0:
          translate = t("modal.spot_programming.spot.options.spotPosition.first")
          break;
        case 1:
          translate = t("modal.spot_programming.spot.options.spotPosition.second")
          break;
        case 10:
          translate = t("modal.spot_programming.spot.options.spotPosition.third")
          break;
        case 11:
          translate = t("modal.spot_programming.spot.options.spotPosition.fourth")
          break;
        case 12:
          translate = t("modal.spot_programming.spot.options.spotPosition.fifty")
          break;
        case 2:
          translate = t("modal.spot_programming.spot.options.spotPosition.indistict")
          break;
        case 22:
          translate = `${t("modal.spot_programming.spot.options.spotPosition.penultimate")} ${t("modal.spot_programming.spot.options.spotPosition.fourth")}`
          break;
        case 21:
          translate = `${t("modal.spot_programming.spot.options.spotPosition.penultimate")} ${t("modal.spot_programming.spot.options.spotPosition.third")}`
          break;
        case 20:
          translate = `${t("modal.spot_programming.spot.options.spotPosition.penultimate")} ${t("modal.spot_programming.spot.options.spotPosition.second")}`
          break;
        case 3:
          translate = `${t("modal.spot_programming.spot.options.spotPosition.penultimate")} ${t("modal.spot_programming.spot.options.spotPosition.first")}`
          break;
        case 4:
          translate = t("modal.spot_programming.spot.options.spotPosition.last")
          break;
      }
      return translate;
    }

    async function cancelAndReplace() {
      store.dispatch('loading_setActive', true);
      const response = await store.dispatch('spots_cancelAndReplace', {id: route.params.id});
      
      const tab = {
        id: response.id,
        module: 'spot_programming',
        name: 'spot/detail',
        extendedData: response
      };
      await store.dispatch('tabs_addTab', tab);
      await store.dispatch('tabs_setActive', tab);
      router.push(`/${tab.module}/${tab.name}/${tab.id}`);
      await store.dispatch('tabs_removeTab', {id: route.params.id});

      setTimeout(() => {
        tabChanges.value = false;
        modelSpot.value = tab.extendedData;
        filterAdvancedSchedules();
        orderSimpleSchedules();
        store.dispatch('loading_setActive', false);
      })
    }

    watch(() => route.params.id, () => {
      const tab = store.getters.tabs_getActive;
      tabChanges.value = tab.extendedData.changes;
      modelSpot.value = tab.extendedData;
      if (tab.module == "spot_programming" && tab.name == "spot/detail") {
        filterAdvancedSchedules();
        orderSimpleSchedules();
      }
    }); 

    return {
      v$,
      listStations,
      listAgencies,
      listOrigin,
      listClients,
      listMethod,
      listSpots,
      listAccountExecutive,
      getShowById,
      modelSpot,
      positionHover,
      detailProgrammingMonthSelect,
      spotAdvancedSchedulesFiltered,
      submitted,
      openModalSchedule,
      orderBy,
      tabChanges,
      sortAdvanced,
      sortSimple,
      createOrEdit,
      deleteItem,
      formatDate,
      getDateInMonth,
      setPositionHover,
      save,
      update,
      filterAdvancedSchedules,
      changeInput,
      saveAndTest,
      getTranslatePosition,
      cancelAndReplace,
      orderAdvancedSchedules,
      orderSimpleSchedules
    }
  },
  validations () {
    return {
      modelSpot: {
        stationId: {required},
        clientId: {required},
        spotCategoryId: {required},
        name: {required}
			}
    }
  }
}
</script>
<style lang="scss" scoped>
  .box-style {
    width: 100%;
    background: #202020;
    border-radius: 12px;
    padding: 12px;
    margin-bottom: 12px;
  }
  
  .column-detail {
    width: 380px;
    word-break: break-word;
  }

  .input__occurrences {
    width: 30px; 
    background: none; 
    border: none; 
    color: white;
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
    text-align: center;
    &::-webkit-inner-spin-button, 
    &::-webkit-outer-spin-button { 
      -webkit-appearance: none;
    }
  }

  .with-value {
    background: #606060;
  }

  th, td {
    &.hover:not(.with-value) {
      background: #6060607e !important;
      transition: .1s;
      cursor: pointer;
    }
  }

  th:has(.column-filtered:hover) {
    background: #6060607e;
  }
  
  .td-filename {
    white-space: nowrap;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .column-time {
    width: 138px;
  }

  .column-filtered {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &:has(th:hover) th { 
      background: #6060607e;
    }

    i {
      display: none;
      margin-top: -2px;

      &.active {
        display: block;
      }
    }
  }

  .actions {
    width: 120px;
  }

  .bg-black {
    background: #101010;
    padding: 12px 4px;
    justify-content: flex-end;
    left: 0px;
    bottom: 0px;
  }
</style>